<!-- eslint-disable import/no-unresolved -->
<template>
  <div>
    <b-card>

      <b-form>

        <!-- accoint details tab -->
        <validation-observer
          ref="invoiceRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Business Details
              </h5>
              <!-- <small class="text-muted">Please fill out this E-invoicing Form, with the required information</small> -->
            </b-col>
            <!-- Contact Number -->
            <b-col md="12">
              <b-form-group
                label=" Account Type"
                label-for="account_type"
              >
                <v-select
                  id="account_type"
                  v-model="data.account_type"
                  placeholder="Select Account Type"
                  :options="accountTypeOptions"
                  :reduce="val => val.value"
                  @input="showHideCompany"
                />
              </b-form-group>
            </b-col>
            <b-col
              v-if="!showIsCompany"
              md="12"
            >
              <b-form-group label="Do you need E-invoice?">
                <b-form-radio-group
                  v-model="data.is_need_invoice"
                  name="invoice-radio"
                  label-for="invoice-radio"

                  @change="handleCheckboxChange($event)"
                >
                  <b-form-radio :value="true">
                    Yes
                  </b-form-radio>
                  <b-form-radio :value="false">
                    No
                  </b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <!-- Business Registration No -->
            <template v-if="data.is_need_invoice || data.is_details">
              <b-col
                v-if="showIsCompany"
                md="12"
              >
                <b-form-group
                  label-for="company_name"
                >
                  <template v-slot:label>
                    Company Name <span class="text-danger">*</span>
                  </template>
                  <small>Full Name (same as SSM / NRIC)</small>
                  <validation-provider
                    #default="{ errors }"
                    name="Company Name"
                    rules="required"
                  >
                    <b-form-input
                      id="firm_name"
                      v-model="data.firm_name"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Enter company name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="showIsCompany"
                md="12"
              >
                <b-form-group
                  label-for="business_registration_no"
                >
                  <template v-slot:label>
                    Business Registration No <span class="text-danger">*</span>
                  </template>
                  <small>Please insert "NA" if you're an Individual user. E.g. 111222333444 or 12345678-X. (Refer to company SSM)</small>
                  <validation-provider
                    #default="{ errors }"
                    name="Business Registration No"
                    rules="required"
                  >
                    <b-form-input
                      id="business_registration_no"
                      v-model="data.firm_reg_no"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Enter business registration number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label-for="email"
                >
                  <template v-slot:label>
                    User Email
                  </template>
                  <b-form-input
                    id="email"
                    v-model="data.email"
                    placeholder="Enter Email"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label-for="mobile_no"
                >
                  <template v-slot:label>
                    Contect Number
                  </template>
                  <b-form-input
                    id="mobile_no"
                    v-model="data.mobile"
                    placeholder="Enter mobile no"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label-for="nric_passport_no"
                >
                  <template v-slot:label>
                    NRIC/Passport No <span class="text-danger">*</span>
                  </template>
                  <small>Please insert "NA" if you're a Company user </small>
                  <validation-provider
                    #default="{ errors }"
                    name="NRIC/Passport No"
                    rules="required"
                  >
                    <b-form-input
                      id="nric_passport_no"
                      v-model="data.nric_passport_no"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Enter NRIC/Passport number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Tax Identification Number -->
              <b-col md="12">
                <b-form-group
                  label-for="tin"
                >
                  <template v-slot:label>
                    Tax Identification Number <span class="text-danger">*</span>
                  </template>
                  <small>Tax No issued by LHDN: E.g.  C1234567890 .    Please insert "NA" if not applicable </small>
                  <validation-provider
                    #default="{ errors }"
                    name="Tax Identification Number"
                    rules="required"
                  >
                    <b-form-input
                      id="tin"
                      v-model="data.tax_identification_number"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Enter tax identification number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- SST Number -->
              <b-col
                v-if="showIsCompany"
                md="12"
              >
                <b-form-group
                  label-for="sst_number"
                >
                  <template v-slot:label>
                    SST Number <span class="text-danger">*</span>
                  </template>
                  <small>E.g. STN-YYMM-XXXXXXXX. Please insert "NA" if it's a non-SST registered company</small>
                  <validation-provider
                    #default="{ errors }"
                    name="SST Number"
                    rules="required"
                  >
                    <b-form-input
                      id="sst_number"
                      v-model="data.sst_number"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Enter SST number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Tourism Tax Registration Number -->
              <b-col
                v-if="showIsCompany"
                md="12"
              >
                <b-form-group
                  label-for="tourism_tax_registration_number"
                >
                  <template v-slot:label>
                    Tourism Tax Registration Number <span class="text-danger">*</span>
                  </template>
                  <small>Please insert "NA" if not applicable</small>
                  <validation-provider
                    #default="{ errors }"
                    name="Tourism Tax Registration Number"
                    rules="required"
                  >
                    <b-form-input
                      id="tourism_tax_registration_number"
                      v-model="data.tourism_tax_registration_number"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Enter tourism tax registration number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- MSIC Code -->
              <b-col
                v-if="showIsCompany"
                md="12"
              >
                <b-form-group
                  label-for="msic_code"
                >
                  <template v-slot:label>
                    MSIC Code <span class="text-danger">*</span>
                  </template>
                  <small>Please refer to this URL if you're unsure your MSIC code: (Refer to company SSM: Article14)

                    <a href="https://sdk.myinvois.hasil.gov.my/codes/msic-codes/">https://sdk.myinvois.hasil.gov.my/codes/msic-codes/</a>
                  </small>
                  <validation-provider
                    #default="{ errors }"
                    name="MSIC Code"
                    rules="required"
                  >
                    <b-form-input
                      id="msic_code"
                      v-model="data.msic_code"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Enter MSIC code"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-form-group
                  label-for="address1"
                >
                  <template v-slot:label>
                    Address1 <span class="text-danger">*</span>
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Address1"
                    rules="required"
                  >
                    <b-form-input
                      id="address"
                      v-model="data.address"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Enter Address Lin 1"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label-for="address2"
                >
                  <template v-slot:label>
                    Address2 <span class="text-danger">*</span>
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Address2"
                    rules="required"
                  >
                    <b-form-input
                      id="address"
                      v-model="data.address2"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Enter Address Lin 2"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label-for="postcode"
                >
                  <template v-slot:label>
                    Postal Code <span class="text-danger">*</span>
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Postal Code"
                    rules="required"
                  >
                    <b-form-input
                      id="postcode"
                      v-model="data.postcode"
                      :state="errors.length > 0 ? false:null"
                      type="number"
                      placeholder="Enter Post Code"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label-for="city"
                >
                  <template v-slot:label>
                    City <span class="text-danger">*</span>
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="City"
                    rules="required"
                  >
                    <b-form-input
                      id="city"
                      v-model="data.city"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Enter City Name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <validation-provider
                  #default="{ errors }"
                  name="Country"
                  rules="required"
                >
                  <b-form-group
                    label="Country"
                    label-for="country"
                    :state="errors.length > 0 ? false:null"
                  >
                    <v-select
                      id="country"
                      v-model="data.country"
                      placeholder="Select Country"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="countryOptions"
                      :reduce="val => val.value"
                    />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="12">
                <validation-provider
                  #default="{ errors }"
                  name="State"
                  rules="required"
                >
                  <b-form-group
                    label="State"
                    label-for="state"
                    :state="errors.length > 0 ? false:null"
                  >
                    <v-select
                      id="State"
                      v-model="data.state"
                      placeholder="Select State"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="stateOptions"
                      :reduce="val => val.value"
                    />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- Submit Button -->
              <b-col cols="12">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  v-b-modal.otp-check
                  variant="primary"
                  class="mt-1 mr-1"
                >Submit</b-button>
              </b-col>
            </template>
          </b-row>
        </validation-observer>
      <!-- address  -->
      </b-form>
    </b-card>
    <validation-observer
      ref="otp_check"
      tag="form"
    >
      <b-modal
        id="otp-check"
        modal-class="modal-primary"
        centered
        title="Verify OTP"
      >
        <b-card-text>
          <label>OTP</label>
          <validation-provider
            #default="{ errors }"
            rules="required|min:6|validSmSOtp"
            name="OTP"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="sms-otp"
                v-model="otp"
                type="number"
                name="otp"
                placeholder="Enter OTP"
              />

            </b-input-group>
            <small
              v-if="errors[0]!='OTP is not valid.'"
              class="text-danger"
            >{{ errors[0] }}</small>
            <small
              v-if="validMessge !='' && errors[0]=='OTP is not valid.'"
              class="text-danger"
            >{{ validMessge }}</small>
            <small
              v-if="validtrueMessge !=''"
              class="text-success"
            >{{ validtrueMessge }}</small>
          </validation-provider>
        </b-card-text>

        <template #modal-footer>
          <b-button
            v-if="!send_otp"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-1 mr-1"
            size="sm"
            @click="requetOTP"
          >
            Send OTP
          </b-button>
          <b-button
            v-else
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-1 mr-1"
            size="sm"
            @click="requetOTP"
          >
            Resend OTP
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-1 mr-1"
            size="sm"
            @click="updateInfo"
          >
            Submit
          </b-button>
        </template>
      </b-modal>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import vSelect from 'vue-select'
import * as rules from 'vee-validate/dist/rules'
import { messages } from 'vee-validate/dist/locale/en.json'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BForm,
  BButton,
  BModal,
  BCardText,
  BFormRadio,
  BFormRadioGroup,
  BFormInvalidFeedback,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required, email } from '@validations'
import SecureLS from 'secure-ls'
import UserService from '../../services/user.service'
import CommonService from '../../services/common.service'

Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule], // assign message
  })
})
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormGroup,
    BCard,
    vSelect,
    BFormInput,
    BForm,
    BButton,
    BModal,
    BFormRadioGroup,
    BCardText,
    BFormRadio,
    BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      stateOptions: [],
      rankOptions: [],
      planOptions: [],
      countryOptions: [],
      required,
      showIsCompany: true,
      email,
      gender: '',
      otp: '',
      send_otp: false,
      accountTypeOptions: [
        { value: 'individual', label: 'Individual Account' },
        { value: 'company', label: 'Company Account' },
      ],
      data: {},
      date: '',
      validtrueMessge: '',
      validMessge: '',
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD', // Uses 'iso' if missing
      },
    }
  },
  mounted() {
    const validSmSOtp = value => {
      const ls = new SecureLS({
        encodingType: 'aes',
        isCompression: false,
      })

      return UserService.vaildSmsOTP({ mobile: this.data.mobile, code: value, secureWord: ls.get('secureWord') }).then(
        response => {
          if (response.success) {
            this.otp = value
            this.success = true
            this.showTimer = false
            this.stopTrying = false
            this.validtrueMessge = response.message
          } else {
            this.validMessge = response.message
          }
          return {
            valid: response.success,
            data: {
              message: response.message,
            },
          }
        },
        error => {
          this.success = false
          this.validMessge = error.response.data.message
          this.stopTrying = error.response.data.data.stopTrying
          this.validtrueMessge = ''
          return {
            valid: false,
            data: {
              message: error.response.data.message,
            },
          }
        },
      )
    }
    extend('validSmSOtp', {
      validate: validSmSOtp,
      message: '',
    }, {
      immediate: false,
    })
  },
  created() {
    this.getUserBusinessInfo()
    this.getState()
    this.getCountry()
  },
  methods: {
    handleCheckboxChange(event) {
      this.data.is_need_invoice = event
    },
    getUserBusinessInfo() {
      UserService.getBusinessDetailseData().then(
        response => {
          console.log(response.user_details)
          if (response.user_details) {
            this.data = response.user_details
            if (this.data.account_type == 'company') {
              this.showIsCompany = true
            } else {
              this.showIsCompany = false
            }
          }
        },
      )
    },
    getState() {
      CommonService.getState().then(
        response => {
          const self = this
          response.state.map((value, key) => {
            self.stateOptions.push(
              { value: value.state, label: value.state },
            )
          })
        },
        error => {},
      )
    },
    getCountry() {
      CommonService.getCoutry().then(
        response => {
          const self = this
          response.country.map((value, key) => {
            self.countryOptions.push(
              { value: value.country, label: value.country },
            )
          })
        },
        error => {},
      )
    },
    requetOTP() {
      this.loading = true
      this.send_otp = true
      UserService.requestOTP({ mobile: this.data.mobile }).then(
        response => {
          this.error = false
          const ls = new SecureLS({
            encodingType: 'aes',
            isCompression: false,
          })
          ls.set('secureWord', response.secureWord)
          ls.set('stopTrying', response.stopTrying)
          this.stopTrying = response.stopTrying
          this.showTimer = 1
          this.waitingTime = response.waitingTime * 1000
          this.loading = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'OTP',
              text: response.message,
              icon: 'EditIcon',
              variant: 'success',
            },
          })
        },
        error => {
          this.loading = false
          const self = this
          if (error.response.errors != undefined) {
            Object.entries(error.response.data.errors).map((value, key) => {
              self.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error',
                  text: value[1][0],
                  icon: 'LockIcon',
                  variant: 'danger',
                },
              })
            })
          } else {
            this.errorShow = true
            this.message = error.response.data.message
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'OTP',
                text: error.response.data.message,
                icon: 'LockIcon',
                variant: 'danger',
              },
            })
          }
        },
      )
    },
    updateInfo() {
      this.$refs.otp_check.validate().then(success => {
        if (success) {
          this.$refs.invoiceRules.validate().then(inSuccess => {
            if (inSuccess) {
              const ls = new SecureLS({
                encodingType: 'aes',
                isCompression: false,
              })
              this.data.otp = this.otp
              this.data.secureWord = ls.get('secureWord')
              UserService.addOrUpdateBusinessDetails(this.data).then(
                response => {
                  this.$bvModal.hide('otp-check')
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'User Update',
                      text: response.message,
                      icon: 'EditIcon',
                      variant: 'success',
                    },
                  })
                  window.location.reload()
                },
                error => {
                  const self = this
                  if (error.response.data.errors != undefined) {
                    Object.entries(error.response.data.errors).map((value, key) => {
                      self.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Error',
                          text: value[1][0],
                          icon: 'EditIcon',
                          variant: 'danger',
                        },
                      })
                    })
                  } else {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Error',
                        text: error.response.data.message,
                        icon: 'EditIcon',
                        variant: 'danger',
                      },
                    })
                  }
                },
              )
            }
          })
        }
      })
    },
    showHideCompany() {
      if (this.data.account_type == 'company') {
        this.showIsCompany = true
        this.data.is_need_invoice = true
      } else {
        this.showIsCompany = false
        if (!this.data.is_details) {
          this.data.is_need_invoice = false
        }
      }
    },
  },
}

</script>
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';

  label {
      color: #161d31;
      font-size: 1rem;
  }

  small, .small {
    font-size: 1rem;
    font-weight: 500;
    color: #161d31;
}

  </style>
